import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { optionsTradesDataType } from '../pages/typings/options.typings'
import { DropDownExpiries, OptionExpiryType, OptionType, OptionsStateType } from '../reducer/options.reducer'
import { RootState } from '../store'

const state = (state: RootState) => state.optionsStore as OptionsStateType

export const selectOptionsTradeData = createDraftSafeSelector(state, (state) => state.tradeData as OptionsStateType['tradeData'])

export const selectUnderlyingOptionsTradeData = (key: string) => createDraftSafeSelector(state, (state) => {
    return (state.tradeData[key] || undefined) as optionsTradesDataType[] | undefined
})

export const selectOptionsChainUnderlyingPrices = (key: string) => createDraftSafeSelector(state, (state) => {
    return state?.underlyingPrice?.[key]
})

export const selectUnderlyingOptionsExpiriesAll = (excludeDerived = true) => 
    createDraftSafeSelector(state, (state) => {
        const expiriesArray = Object.values(state.dropdownExpiries || {}).flat() as DropDownExpiries[] | undefined;
        return excludeDerived ? expiriesArray?.filter((d) => !d.derived) : expiriesArray;
    });

export const selectOptionsExpiries = createDraftSafeSelector(state, (state) => state.dropdownExpiries)

export const selectUnderlyingOptionsExpiriesV2 = (key: string, excludeDerived = true) => createDraftSafeSelector(state, (state) => {
    return excludeDerived ? ((state.dropdownExpiriesExcludedDerived[key] || undefined) as DropDownExpiries[] | undefined) : (state.dropdownExpiries[key] || undefined) as DropDownExpiries[] | undefined
})

export const selectUnderlyingOptionsTradeExpiryData = (key?: string, expiry?: number) => createDraftSafeSelector(state, (state) => {
    if (!key || expiry === undefined || expiry === null) return {} as optionsTradesDataType
    return (((state.tradeData[key] || []) as optionsTradesDataType[]).find(o => o.expiration.expiry?.expiry === expiry) ?? {}) as optionsTradesDataType
})

export const selectUnderlyingOptionsExpiries = (key: string) => createDraftSafeSelector(state, (state) => {
    return (state.expiries[key] || undefined) as OptionExpiryType[] | undefined
})

export const selectOptionsExpiryToStrikesMap = (key: string) => createDraftSafeSelector(state, (state) => {
    return (state.expiryToStrikesMap[key] || {}) as Record<string, string[]>
})

export const selectOptionToStrikeMap = (key: string) => createDraftSafeSelector(state, (state) => {
    return (state.optionToStrikeMap[key] || {}) as Record<string, OptionType>
})

export const selectStrikeToOptionsMap = (key: string) => createDraftSafeSelector(state, (state) => {
    return (state.strikeMap[key] || {})
})

export const selectStrikeToOptions = (key: string, strikeKey: string) => createDraftSafeSelector(state, (state) => {
    return (state.strikeMap[key]?.[strikeKey] || {})
})

export const selectPastOptionExpiriesV2 = (key: string) => createDraftSafeSelector(state, (state) => {
    return (state.dropdownPastExpiries[key] || undefined) as DropDownExpiries[] | undefined
})

export const selectSimulatorOrdersLiveData = createDraftSafeSelector(state, (state) => {
    return (state.simulatorOrdersLiveData || {})
})

export const selectSimulatorOrderLiveData = (orderId: string) => createDraftSafeSelector(state, (state) => {
    return state?.simulatorOrdersLiveData?.[orderId]
})

export const selectOptionChainDrawerOpen = createDraftSafeSelector(state, (state) => {
    return state.drawerOpen
})